import { APP_NAME_URL, APP_SHORT_BLURB } from '../../constants';
import Head from 'next/head';
import { PageProviders } from 'app/features/silo/PageProviders';
import { Dashboard } from 'app/features/dashboard';

const Main = () => {
  return (
    <>
      <Head>
        <title>{APP_NAME_URL}</title>
        <meta key="description" name="description" content={APP_SHORT_BLURB} />
      </Head>

      <Dashboard />
    </>
  );
};

export default Main;
Main.whyDidYouRender = true;
Main.Provider = PageProviders;
